/**
 * Quiet Luxury Archives — merge all collection pages, then sort by color / silhouette.
 * Grid stays hidden until sort finishes to avoid flash of Shopify default order.
 */
(function () {
  'use strict';

  var grid = document.querySelector('#product-grid[data-ql-archives-sort="true"]');
  if (!grid) return;

  var COLOR_ORDER = [
    'black',
    'navy',
    'brown',
    'beige',
    'grey',
    'white',
    'bordeaux',
    'olive',
    'blue',
    'other'
  ];
  var COLOR_LABELS = {
    black: 'Black',
    navy: 'Navy',
    brown: 'Brown',
    beige: 'Beige',
    grey: 'Grey',
    white: 'White',
    bordeaux: 'Bordeaux',
    olive: 'Olive',
    blue: 'Blue',
    other: 'Archive'
  };
  var TYPE_ORDER = [
    'triple',
    'track',
    'jacket',
    'gilet',
    'tee',
    'longsleeve',
    'shorts',
    'pants',
    'other'
  ];

  function pad(s) {
    return (
      ' ' +
      String(s || '')
        .toLowerCase()
        .replace(/[-_]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim() +
      ' '
    );
  }

  function detectColor(hay) {
    if (/\bblack\b|\bnoir\b|\bschwarz\b|\bonyx\b/.test(hay)) return 'black';
    if (/\bnavy\b|\bmarine\b/.test(hay)) return 'navy';
    if (/\bbrown\b|\bbraun\b|\bespresso\b|\bmocha\b|\bchocolate\b|\bcognac\b/.test(hay)) return 'brown';
    if (/\bbeige\b|\bsand\b|\btaupe\b|\bcream\b|\bcreme\b|\becru\b|\bcamel\b/.test(hay)) return 'beige';
    if (
      /\bgrey\b|\bgray\b|\bgrau\b|\bcharcoal\b|\bgraphite\b|\banthracite\b|\bantracit\b/.test(hay)
    ) {
      return 'grey';
    }
    if (/\bwhite\b|\bivory\b|\bweiss\b|\boff white\b|\balabaster\b/.test(hay)) return 'white';
    if (/\bbordeaux\b|\bburgundy\b|\bwine\b|\boxblood\b|\bmerlot\b/.test(hay)) return 'bordeaux';
    if (/\bolive\b|\bsage\b|\bforest\b/.test(hay)) return 'olive';
    if (/\bsky\b|\bcobalt\b|\bindigo\b|\bdenim\b|\bblue\b/.test(hay)) return 'blue';
    return 'other';
  }

  function detectType(hay) {
    if (/\btriple\b|\bbundle\b/.test(hay)) return 'triple';
    if (/\bhooded\b|\btrack\b|\btech set\b|\btracksuit\b/.test(hay)) return 'track';
    if (/\bjacket\b|\bwindbreaker\b|\bouter\b/.test(hay)) return 'jacket';
    if (/\bgilet\b|\bvest\b/.test(hay)) return 'gilet';
    if (/\blong sleeve\b|\blongsleeve\b/.test(hay)) return 'longsleeve';
    if (/\bt shirt\b|\btshirt\b|\btee\b|\bshiny\b|\bpolo\b/.test(hay)) return 'tee';
    if (/\bshort\b/.test(hay)) return 'shorts';
    if (/\bpant\b|\bchino\b|\btrouser\b|\bpantalon\b/.test(hay)) return 'pants';
    if (/\bset\b/.test(hay)) return 'track';
    return 'other';
  }

  function metaFromItem(item) {
    var title =
      (item.getAttribute('data-ql-title') || '') +
      ' ' +
      (item.getAttribute('data-ql-handle') || '');
    var hay = pad(title);
    return {
      color: item.getAttribute('data-ql-color') || detectColor(hay),
      type: item.getAttribute('data-ql-type') || detectType(hay)
    };
  }

  function existingHandles() {
    var set = {};
    grid.querySelectorAll(':scope > li.grid__item[data-ql-handle]').forEach(function (el) {
      set[el.getAttribute('data-ql-handle')] = true;
    });
    return set;
  }

  function collectPageUrls() {
    var urls = [];
    var seen = {};
    var maxPage = 1;

    document.querySelectorAll('.pagination a[href], nav.pagination a[href]').forEach(function (a) {
      var href = a.href;
      if (!href) return;
      try {
        var u = new URL(href, window.location.origin);
        var p = parseInt(u.searchParams.get('page') || '1', 10);
        if (p > maxPage) maxPage = p;
      } catch (e) {}
      if (seen[href]) return;
      if (!/[?&]page=\d+/.test(href) && href.indexOf('page=') === -1) return;
      seen[href] = true;
      urls.push(href);
    });

    try {
      var base = new URL(window.location.href);
      for (var p = 2; p <= Math.max(maxPage, 2); p++) {
        base.searchParams.set('page', String(p));
        var u = base.toString();
        if (!seen[u]) {
          seen[u] = true;
          urls.push(u);
        }
      }
    } catch (e) {}

    return urls;
  }

  function mergeItemsFromHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var remoteGrid = doc.querySelector('#product-grid');
    if (!remoteGrid) return 0;
    var known = existingHandles();
    var added = 0;
    remoteGrid.querySelectorAll(':scope > li.grid__item[data-ql-handle]').forEach(function (li) {
      var handle = li.getAttribute('data-ql-handle');
      if (!handle || known[handle]) return;
      known[handle] = true;
      grid.appendChild(document.importNode(li, true));
      added++;
    });
    return added;
  }

  function sortGrid() {
    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > li.grid__item'));
    if (!items.length) return;

    grid.querySelectorAll(':scope > li.ql-archives-color-break').forEach(function (el) {
      el.remove();
    });

    items.forEach(function (item) {
      var meta = metaFromItem(item);
      item.setAttribute('data-ql-color', meta.color);
      item.setAttribute('data-ql-type', meta.type);
    });

    items.sort(function (a, b) {
      var ca = COLOR_ORDER.indexOf(a.getAttribute('data-ql-color') || 'other');
      var cb = COLOR_ORDER.indexOf(b.getAttribute('data-ql-color') || 'other');
      if (ca < 0) ca = COLOR_ORDER.length;
      if (cb < 0) cb = COLOR_ORDER.length;
      if (ca !== cb) return ca - cb;
      var ta = TYPE_ORDER.indexOf(a.getAttribute('data-ql-type') || 'other');
      var tb = TYPE_ORDER.indexOf(b.getAttribute('data-ql-type') || 'other');
      if (ta < 0) ta = TYPE_ORDER.length;
      if (tb < 0) tb = TYPE_ORDER.length;
      if (ta !== tb) return ta - tb;
      var ha = a.getAttribute('data-ql-handle') || '';
      var hb = b.getAttribute('data-ql-handle') || '';
      return ha < hb ? -1 : ha > hb ? 1 : 0;
    });

    var frag = document.createDocumentFragment();
    var lastColor = null;

    items.forEach(function (item) {
      var color = item.getAttribute('data-ql-color') || 'other';
      if (color !== lastColor) {
        lastColor = color;
        var breakLi = document.createElement('li');
        breakLi.className = 'ql-archives-color-break';
        breakLi.setAttribute('data-ql-color-break', color);
        var title = document.createElement('h2');
        title.className = 'ql-archives-color-break__title';
        title.textContent = COLOR_LABELS[color] || 'Archive';
        breakLi.appendChild(title);
        frag.appendChild(breakLi);
      }
      frag.appendChild(item);
    });

    grid.appendChild(frag);

    document.querySelectorAll('.pagination, nav.pagination, .pagination-wrapper').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function reveal() {
    grid.setAttribute('data-ql-archives-ready', 'true');
    document.documentElement.classList.add('ql-archives-ready');
  }

  function run() {
    /* Clickable immediately — sort/merge may still refine order */
    reveal();
    var urls = collectPageUrls();
    if (!urls.length) {
      sortGrid();
      reveal();
      return;
    }

    Promise.all(
      urls.map(function (url) {
        return fetch(url, { credentials: 'same-origin' })
          .then(function (r) {
            return r.ok ? r.text() : '';
          })
          .catch(function () {
            return '';
          });
      })
    ).then(function (pages) {
      pages.forEach(function (html) {
        if (html) mergeItemsFromHtml(html);
      });
      sortGrid();
      reveal();
    });
  }

  /* Failsafe: never leave the grid waiting long */
  setTimeout(function () {
    if (grid.getAttribute('data-ql-archives-ready') !== 'true') {
      sortGrid();
      reveal();
    }
  }, 900);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
